import { graphql } from 'gatsby';
import Link from '@/components//Link/Link';
import type { BlockHTMLClassName } from '@/utils/renderBlock';

import { StyledContainer } from './LinkGroup.styles';

const LinkGroup = ({ elements, className }: Queries.LINK_GROUPFragment & BlockHTMLClassName) => {
  const { links } = elements;

  return (
    <StyledContainer className={className}>
      {links.value.map((link, index) => (
        <Link key={link.system.id} {...link} variant={index === 0 ? 'primary' : 'secondary'} />
      ))}
    </StyledContainer>
  );
};

export default LinkGroup;

export const fragment = graphql`
  fragment LINK_GROUP on kontent_item_link_group {
    __typename
    system {
      codename
    }
    elements {
      links {
        value {
          system {
            id
          }
          ...LINK
        }
      }
    }
  }
`;
